import api from "../lib/api";

export const quoteJobService = {
    searchClients: (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.name) queryParams.append('name', params.name);
        if (params.phone) queryParams.append('phone', params.phone);
        if (params.email) queryParams.append('email', params.email);

        return api.get(`/company/client/all?${queryParams.toString()}`);
    },
    createQuoteJob: (data) => {
        return api.post('/company/quote-job/create', data);
    },
    getServices: () => {
        return api.get('/user/services');
    },
    getLeadSources: () => {
        return api.get('/company/lead-sources');
    },
    getSurveyors: () => {
        return api.get('/company/surveyors');
    },
    getQuotesWithPayments: () => {
        return api.get('/company/quotes/with-payments');
    },
    markQuoteAsPaid: (quoteId, data) => {
        return api.put(`/company/quotes/${quoteId}/mark-as-paid`, data);
    }
};
